export class ProgramResponse {
  basicProgramTypes?: BasicProgramType[];
  programTypes?: ProgramType[];
}

export class BasicProgramType {
  id?: number;
  public name?: string;
  public displayName?: string;
  createdBy?: number;
  updatedBy?: number;
  createdAt?: Date;
  updatedAt?: Date;
  status?: boolean;
  position?: number;

  layoutCode?: number;
  layoutName?: string;

  typeCode?: number;
  typeName?: string;

  createdByName?: string;
  updatedByName?: string;

  count?: number;
  gridRatio?: number;

  background?: CommonFile;
  hubList?: number[];
  public basicProgramList?: BasicProgram[];
}

export class BasicProgram {
  id?: number;
  heading?: string;
  subHeading?: string;
  innerHeading?: string;
  sessions?: number;
  pic?: CommonFile;
  services?: Services;
  createdBy?: string;
  updatedBy?: string;
  createdAt?: Date;
  updatedAt?: Date;
  amount?: number;
  mrp?: number;
  discount?: number;
  discountInPercent?: number;
  status?: boolean;
  programTypeId?: number;
  hubList?: number[];
  cid?: number;
  scid?: number;
  shid?: number;
  sid?: number;
  position?: number;
  cover?: CommonFile;
  servicesList?: number[];
  serviceCharge?: number;
  productCost?: number;
  basicProgramType?: BasicProgramType;
  aboutList?: string[];
}

export class ClaimData {
  id?: number;
  heading?: string;
  subHeading?: string;
  innerHeading?: string;
  sessions?: number;
  pic?: CommonFile;
  services?: Services;
  createdBy?: string;
  updatedBy?: string;
  about?: string;
  createdAt?: Date;
  updatedAt?: Date;
  amount?: number;
  mrp?: number;
  discount?: number;
  discountInPercent?: number;
  status?: boolean;
  programTypeId?: number;
  hubList?: number[];
  cid?: number;
  scid?: number;
  shid?: number;
  sid?: number;
  position?: number;
  cover?: CommonFile;
  servicesList?: number[];
  basicProgramType?: BasicProgramType;
}

export class ProgramType {
  id: number;
  name: string;
  displayName: string;
  createdBy: number;
  updatedBy: number;
  createdAt: Date;
  updatedAt: Date;
  status: boolean;
  position: number;
  layoutCode: number;
  layoutName: string;
  typeCode: number;
  typeName: string;
  hubList: number[];
  createdByName: string;
  updatedByName: string;
  count: number;
  gridRatio: number;
  background: CommonFile;
  hubs: string;
  programList: Program[];
}

export class Program {
  id: number;
  heading: string;
  subHeading: string;
  innerHeading: string;
  sessions: number;
  cover: CommonFile;
  banner: CommonFile;
  services: Services;
  createdBy: number;
  updatedBy: number;
  createdAt: Date;
  updatedAt: Date;
  amount: number;
  mrp: number;
  discount: number;
  hubList: number[];
  discountInPercent: number;
  status: boolean;
  programTypeId: number;
  programType: ProgramType;
  position: number;
  servicesList: number[];
  deepLinkCode: number;
  deepLinkName: string;
  cid: number;
  scid: number;
  shid: number;
  sid: number;
  categoryName: string;
  subCategoryName: string;
  serviceHeadingName: string;
  serviceName: string;
  hubs: string;
  programTypeName: string;
  aboutList: string[];
  productCost: number;
  serviceCharge: number;
  specialPrice: number;
  specialMessage: string;
}

class CommonFile {
  id: string;
  type: string;
  httpPath: string;
  secureHttpPath: string;
  filePath: string;
  format: string;
  contentType: string;
  statusCode: number;
  status: string;

  fileUploadResult: FileUploadResultResponse;
  isActive: boolean;
  isDefault: boolean;

  approvedAt: Date;

  approvedBy: string;

  uploadedBy: Date;

  uploadedAt: Date;
}

class FileUploadResultResponse {
  public_id: string;
  version: number;
  signature: string;
  width: number;
  height: number;
  format: string;
  resource_type: string;
  created_at: string;
  bytes: number;
  type: string;
  url: string;
  secure_url: string;

  file_path: string;
}

class Services {
  id: number;
  name: string;
  subHeading: string;
  serviceTag: string;
  about: string;
  shortDesc: string;
  briefDesc: string;
  min: number;
  cid: number;
  scid: number;
  shid: number;
  aboutList: string[];
  serviceGallery: CommonFile[];
  coverImage: CommonFile;
  banner: CommonFile;
  amount: number;
  mrp: number;
  discount: number;
  discountInPercent: number;
  serviceCharge: number;
  productCost: number;
  descriptions: Description[];
  serviceHubsList: number[];
  genderList: number[];
  status: boolean;
  makeYourOwnPackage: boolean;
  salontymCoins: number;
  cashbackSalontymCoins: number;
  created_at: Date;
  updated_at: Date;
  slug: string;
  createdByName: string;
  updatedByName: string;
  recommended: boolean;
  homeRecommended: boolean;
  lockedService: boolean;
  generalPackage: boolean;
  unlockedAmount: number;
  resultGallery: CommonFile[];
  packageId: string;
  addOn: boolean;
  upgrade: boolean;
  options: boolean;
  optionIds: number[];
  parentIds: number[];
  recommendedServiceIds: number[];
  sort: number;
  productQuantityMeasurements: ProductQuantityMeasurement[];
  productIds: number[];
  claimService: boolean;
  changeProduct: boolean;
  recommendedServiceOnPaymentIds: number[];
  parentServices: string;
  optionServices: string;
  recommendedServices: string;
  products: string;
  cover: File;
  gallery: File[];
  resultFiles: File[];
  categoryName: string;
  subCategoryName: string;
  serviceHeadingName: string;
  franchise: boolean;
  recommendedServiceOnPayment: string;
  editable: boolean;
  hubs: string;
  specialPrice: number;
  specialMessage: string;
}

export class ViewDetailsServices {
  id: number;
  name: string;
  subHeading: string;
  serviceTag: string;
  about: string;
  shortDesc: string;
  briefDesc: string;
  min: number;
  cid: number;
  scid: number;
  shid: number;
  aboutList: string[];
  serviceGallery: CommonFile[];
  coverImage: CommonFile;
  banner: CommonFile;
  amount: number;
  mrp: number;
  discount: number;
  discountInPercent: number;
  serviceCharge: number;
  productCost: number;
  descriptions: Description[];
  serviceHubsList: number[];
  genderList: number[];
  status: boolean;
  makeYourOwnPackage: boolean;
  salontymCoins: number;
  cashbackSalontymCoins: number;
  created_at: Date;
  updated_at: Date;
  slug: string;
  createdByName: string;
  updatedByName: string;
  recommended: boolean;
  homeRecommended: boolean;
  lockedService: boolean;
  generalPackage: boolean;
  unlockedAmount: number;
  resultGallery: CommonFile[];
  packageId: string;
  addOn: boolean;
  upgrade: boolean;
  options: boolean;
  optionIds: number[];
  parentIds: number[];
  recommendedServiceIds: number[];
  sort: number;
  productQuantityMeasurements: ProductQuantityMeasurement[];
  productIds: number[];
  claimService: boolean;
  changeProduct: boolean;
  recommendedServiceOnPaymentIds: number[];
  parentServices: string;
  optionServices: string;
  recommendedServices: string;
  products: string;
  cover: File;
  gallery: File[];
  resultFiles: File[];
  categoryName: string;
  subCategoryName: string;
  serviceHeadingName: string;
  franchise: boolean;
  recommendedServiceOnPayment: string;
  editable: boolean;
  hubs: string;
  specialPrice: number;
  specialMessage: string;
}

class Description {
  id: string;
  title: string;
  points: string[];
  sort: number;
  active: boolean;
}

class ProductQuantityMeasurement {
  productId: number | null;
  count: number | null;
  productCost: number | null;
  change: boolean | null;
  productName?: string;
  categoryName?: string;
  subCategoryName?: string;
  alternateProductsAvailable: boolean | null;
  productQuantityMeasurements: ProductQuantityMeasurement[]; // alternate products

  constructor() {
    this.productId = null;
    this.count = null;
    this.productCost = null;
    this.change = null;
    this.productName = undefined;
    this.categoryName = undefined;
    this.subCategoryName = undefined;
    this.alternateProductsAvailable = null;
    this.productQuantityMeasurements = [];
  }
}

export class ResponseObject {
  status: string;
  message: string;
  statusCode: number;
  object: any;
}

export class CustomerOtpVerificationRequest {
  username: string;
  otp: string;
  prefix: string;
  constructor() {}
}

export class CustomerUpdateRequest {
  dob: string;
  email: string;
  gender: string;
  name: string;
  workEmail: string;
}

export class ServiceRequest {
  addressId: number;
  latitude: number;
  longitude: number;
}

export class Address {
  public id?: number;
  public formattedAddress?: string;
  public latitude?: number;
  public longitude?: number;
  public savedAddress?: boolean;
  public placeId?: string;
  public address?: string;
  public pinCode?: number;
  public city?: string;
  public cityCode?: number;
  public state?: string;
  public stateCode?: number;
  public country?: string;
  public countryCode?: number;
  public hubId?: number;
  public building?: string;
  public locality?: string;
  public landmark?: string;
}

export class LocalAddress {
  formattedAddress: string;
  building: string;
  locality: string;
}

export class ServiceHub {
  public id: number;
  public slug: string;
}

export class BuildTempSlot {
  public start: string;
  public startHour: number;
  public spid: number;
  public end: string;
  public slot: string;
  public hour: number;
  public isSlotFree: boolean; // free min
  public primeTimeCharge: number;
  public primeTime: boolean;
  public selected: boolean;
}

export class CalendarResponse {
  public date: string;
  public epoch: number;
  public day: number;
  public dayShort: string;
  public dayOfWeek: string;
  public shortOfWeek: string;
  public monthString: string;
  public monthStringShort: string;
  public month: number;
  public year: number;
  public specialDate: boolean;
  public buildTempSlots: BuildTempSlot[];
}

export class SlotRequest {
  public date: string;
  public hid: number;
  public cid: number;
  public admin: boolean;
}

export class OrderServiceRequest {
  public sid: number;
  public quantity: number;

  public productQuantityMeasurements: ProductQuantityMeasurement[];
}

export class razorpayOrder {
  public amount: number;
  public currency: string;
  public id: string;
  public status: string;
}
export class RazorpayValidatePayment {
  public paymentId: string;
  public orderId: string;
  public signature: string;
  public razorpayOrder: razorpayOrder;
}

export class OrderRequest {
  public paymentModeCode: number | string;
  public orderServiceRequests: OrderServiceRequest[];
  public suggestion: string;
  public bookingDate: string;
  public bookingSlot: string;
  public addressId: string;
  public hubId: string;
  public cid: string;
  public tempSpId: number; // slot temp id
  public exclusiveSpId: number;
  public calendarResponse: CalendarResponse;
  public buildTempSlot: BuildTempSlot;
  public walletRedeem: boolean;
  public couponCode: string;
  public chatDateAndTime: string;
  public razorpayValidatePayment: RazorpayValidatePayment;
  public freeProductOrderRequest: FreeProductOrderRequest;
  public disposableKitCount: number;
}

export class FreeProductOrderItemRequest {
  public pid: number;
  public quantity: number;
}
export class FreeProductOrderRequest {
  public freeProductOrderItemRequests: FreeProductOrderItemRequest[];

  public addressId: number;
  public orderId: number;
}

interface OrderServices {
  services: {
    name: string;
    coverImage: {
      secureHttpPath: string;
    };
    about: string;
    subHeading: string;
    mrp: number;
    discount: number;
    amount: number;
  };
  total: number;
  totalDiscount: number;
  totalUniversal: number;
}

export class OrderSummary {
  public totalMrp: number;
  public totalDiscount: number;
  public specialDiscount: number;
  public totalAmount: number;
  public walletRedeem: number;
  public couponDiscount: number;
  public finalAmount: number;
  public primeTimeCharge: number;
  public disposableKitAmount: number;
  public transportationCharge: number;
  public cashbackSalontymCoins: number;
  public address: Address;
  public blockCod: boolean;
  public extraMessage: string;
  public customerWalletResponse: CustomerWalletResponse;
  public calendarResponse: CalendarResponse; // for chat services
  public buildTempSlot?: BuildTempSlot;
  public orderServices?: OrderServices[];
  public customer?: Customer;
  public cancellationCharges?: number;
  public subscriptionDiscount?: number;
  public customerSubscribed?: boolean;
}

class CustomerWalletResponse {
  public redeemStatus: boolean;
  public message: string;
  public nextDiscount: string;
  public addMoreAmount: string;
  public wallet: Wallet;
  public maxDiscount: number;
}

class Wallet {
  public walletAmount: number;
  public coins: number; //salontym coins
  public currency: string;
  public walletCreatedDateFormatted: string;
  public walletExpireDateFormatted: string;
  public coinCreatedDateFormatted: string;
  public coinExpireDateFormatted: string;
}

export class AddressRequest {
  building?: string;
  locality?: string;
  landmark?: string;
  pinCode?: number;
  city?: string;
  cityCode?: number;
  state?: string;
  stateCode?: number;
  country?: string;
  countryCode?: number;
  latitude?: number;
  longitude?: number;
  placeId?: string;
  formattedAddress?: string;
}
export class PaymentModeResponse {
  value?: string;
  code?: number;
  name?: string;
  desc?: string;
  icon?: string;
  isSelected?: boolean;
  isWallet?: boolean;
  gateway?: boolean;
  parentCode?: boolean;
  extraMessage?: string;
  blocked?: boolean;

  constructor(
    value?: string,
    code?: number,
    name?: string,
    desc?: string,
    icon?: string,
    isSelected?: boolean,
    isWallet?: boolean,
    gateway?: boolean,
    parentCode?: boolean,
    extraMessage?: string,
    blocked?: boolean
  ) {
    this.value = value;
    this.code = code;
    this.name = name;
    this.desc = desc;
    this.icon = icon;
    this.isSelected = isSelected;
    this.isWallet = isWallet;
    this.gateway = gateway;
    this.parentCode = parentCode;
    this.extraMessage = extraMessage;
    this.blocked = blocked;
  }
}
export class Customer {
  id: number;
  name: string;
  prefix: number;
  mobile: number;
  smobile: number;
  gender: string;
  // @JsonIgnore equivalent can be implemented by a custom serializer if needed
  password?: string;
  email: string;
  createdAt: Date;
  updatedAt: Date;
  mobileVerified: boolean;
  emailVerified: boolean;
  workEmailVerified: boolean;
  active: boolean;
  profile: CommonFile;
  cover: CommonFile;
  customerAddresses: Address[];
  referralWallet: Wallet; // final referral amount
  wallet: Wallet;
  workEmail: string;
  dob: string;
  anniversary: string; // marriage anniversary
  statusCode: number;
  status: string;
  loginAddress: Address;
  referCode: string;
  referLink: string; // customer referlink

  constructor(
    id: number,
    name: string,
    prefix: number,
    mobile: number,
    smobile: number,
    gender: string,
    email: string,
    createdAt: Date,
    updatedAt: Date,
    mobileVerified: boolean,
    emailVerified: boolean,
    workEmailVerified: boolean,
    active: boolean,
    profile: CommonFile,
    cover: CommonFile,
    customerAddresses: Address[],
    referralWallet: Wallet,
    wallet: Wallet,
    workEmail: string,
    dob: string,
    anniversary: string,
    statusCode: number,
    status: string,
    loginAddress: Address,
    referCode: string,
    referLink: string,
    username?: string,
    password?: string
  ) {
    this.id = id;
    this.name = name;
    this.prefix = prefix;
    this.mobile = mobile;
    this.smobile = smobile;
    this.gender = gender;
    this.email = email;
    this.createdAt = createdAt;
    this.updatedAt = updatedAt;
    this.mobileVerified = mobileVerified;
    this.emailVerified = emailVerified;
    this.workEmailVerified = workEmailVerified;
    this.active = active;
    this.profile = profile;
    this.cover = cover;
    this.customerAddresses = customerAddresses;
    this.referralWallet = referralWallet;
    this.wallet = wallet;
    this.workEmail = workEmail;
    this.dob = dob;
    this.anniversary = anniversary;
    this.statusCode = statusCode;
    this.status = status;
    this.loginAddress = loginAddress;
    this.referCode = referCode;
    this.referLink = referLink;
  }
}

interface GeneralServicePackage {
  id: number;
  name: string;
  inCart: boolean;
}

interface FileInfo {
  secureHttpPath: string;
}
export class BestServiceData {
  generalServicePackageResponses: GeneralServicePackage[];
  backgroundFile?: FileInfo;
}

export class RecommendedItem {
  id: number;
  cid: number;
  coverImage?: {
    secureHttpPath: string;
  };
  inCart: boolean;
  subHeading: string;
  name: string;
  amount: number;
  mrp: number;
  discount: number;
}

export class OfferService {
  expireIn?: number;
  heading?: string;
  servicesList?: ViewDetailsServices[];
  subheading?: string;
}

interface CoverImage {
  secureHttpPath: string;
}

export class ViewDetailsCategory {
  id: number;
  name: string;
  subHeading: string;
  serviceTag: string;
  about: string;
  shortDesc: string;
  briefDesc: string;
  min: number;
  cid: number;
  scid: number;
  shid: number;
  aboutList: string[];
  amount: number;
  mrp: number;
  discount: number;
  discountInPercent: number;
  serviceCharge: number;
  productCost: number;
  imageUrl: string;
  coverImage?: CoverImage;
  banner?: CoverImage;
  descriptions: string;
  cashbackSalontymCoins: string;
  addOn: boolean;
  specialMessage: string;
  specialPrice: number;
}

interface ImageFile {
  id: string;
  type: string | null;
  httpPath: string;
  secureHttpPath: string;
  filePath: string | null;
  format: string;
  contentType: string | null;
  isActive: boolean;
  isDefault: boolean | null;
  statusCode: string | null;
  status: string | null;
}
export class Subscription {
  id: string;
  heading: string;
  subheading: string;
  description: string;
  amountForCashback: number;
  coinsForCashback: number;
  serviceIds: number[];
  discount: number;
  maxDiscount: number;
  minAmount: number;
  redeemType: string;
  redeemTypeCode: number;
  subscriptionType: string;
  subscriptionTypeCode: number;
  validityPeriod: number;
  applicableForMaxOrdersPerDay: number;
  applicableForMinOrdersPerDay: number;
  maxOrders: number;
  primeTime: boolean;
  transport: boolean;
  subscriptionPrice: number;
  subscriptionDiscount: number;
  subscriptionMrp: number;
  imageFile: ImageFile;
  status: boolean;
  createTime: number;
  updateTime: number;
  createdBy: string | null;
  updatedBy: number;
  buttonLabel: string | null;
  buttonActive: boolean | null;
  hubIds: number[];
  descriptions: string[];
}

interface ProfileImage {
  secureHttpPath: string;
}

interface Product {
  id: number;
  cid: number;
  scid: number;
  brandId: number;
  name: string;
  title: string;
  count: number | null;
  shortDescription: string | null;
  commonFile: string | null;
  minOrderProductLimit: number | null;
  maxOrderProductLimit: number | null;
  productDeductOnService: number | null;
  createdBy: number;
  updatedBy: number;
  createdAt: number;
  updatedAt: number;
  status: boolean;
  basePrice: number;
  mrp: number;
  discountForSp: number;
  discountForCustomer: number;
  priceForSp: number;
  priceForCustomer: number;
  minStockInHub: number | null;
  maxStockInHub: number | null;
  productVideoLink: string | null;
  cashback: number | null;
  salontymCoins: number;
  cashbackSalontymCoins: number;
  about: string;
  descriptions: Description[];
  forCustomers: boolean;
  profileImage: ProfileImage;
  productQuantityDisplayName: string;
  cover: string | null;
  galleryMultipartFiles: string | null;
  createdByName: string | null;
  updatedByName: string | null;
  categoryName: string | null;
  subCategoryName: string | null;
  brandName: string | null;
  liveStock: number | null;
  sort: string | null;
}
interface productCartDetails {
  pid: number;
  quantity: number;
  product: Product;
  totalCoins: number;
  totalCashBackCoins: number;
}
interface walletInfo {
  totalCoins: number;
  remainingCoins: number;
}
export class ProductDetails {
  aid: number;
  cashbackCoins: number;
  cid: number;
  id: number;
  orderCompleted: number;
  productCartDetails: productCartDetails[];
  totalCoins: number;
  walletInfo: walletInfo;
}

interface franchiseFacts {
  header: string;
  content: string[];
}

interface franchiseResponseSupports {
  heading: string;
  description: string;
}

export class FranchiseData {
  franchiseFacts: franchiseFacts[];
  franchiseResponseSupports: franchiseResponseSupports[];
}

export class BannerMobile {
  mobileImage: {
    secureHttpPath: string;
  };
}

export interface OrderJourneyTracking {
  code: number;
  completed: boolean;
  value: string;
  valueShort: string;
}

export class AppointmentDetails {
  totalAmount?: number;
  totalDiscount?: number;
  couponDiscount?: number;
  disposableKitAmount?: number;
  walletRedeem?: number;
  transportationCharge?: number;
  primeTimeCharge?: number;
  cancellationCharges?: number;
  finalAmount?: number;
  totalCashbackSalontymCoins?: number;
  doid?: number;
  bookingDate?: string;
  bookingSlot?: string;
  orderStatus?: { value: string; code: number };
  otp?: number;
  orderServices?: OrderServices[];
  totalMin?: number;
  totalMrp?: number;
  paymentMode?: string;
  paymentModeCode?: number;
  address?: Address;
  sharedAddress?: Address;
  orderJourneyTracking?: OrderJourneyTracking[];
  sp: any;
  id?: number;
  customerFeedback?: any;
}
